module.exports = __webpack_public_path__ + "static/media/icon-menu.f7d4dc2a.svg";